function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { PanelType, RangeState, RcCompareRangeDateProvider, RcDateProvider, useCompareRangeDate } from '../../hooks/date';
import { RcPopper } from '../../hooks/popper';
import { useRefCallback, useToggle } from '@bydesign-ui/hooks';
import { classnames, prevDate, prevYear } from '@bydesign-ui/utils';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { ActiveTab, CompareRangeDateFooter, CompareRangeDateHeader, DateComparisonInput, DateContainer, DatePreset, MultiplePopperWrapper, ViewWrapper, setRangePanelDate, updateRangePanelDate } from '../../units/date';

function defaultGetTargetPresets(sourceValue, offset, mom, yoy) {
  if (!sourceValue.length) {
    return [];
  }

  return [{
    label: mom,
    key: 'chain',
    value: offset == null ? [] : [prevDate(sourceValue[0], offset), prevDate(sourceValue[0])]
  }, {
    label: yoy,
    key: 'last-year-chain',
    value: offset == null ? [] : [prevYear(sourceValue[0]), prevYear(sourceValue[1])]
  }];
}

export function DateComparisonPicker(props) {
  var locale = useLocale('date');
  var panelRef = useRef(null);

  var _useState = useState(ActiveTab.SOURCE),
      _useState2 = _slicedToArray(_useState, 2),
      tab = _useState2[0],
      setTab = _useState2[1];

  var localePlaceholder = useLocale('date-comparison.placeholder');
  var localeSource = useLocale('date-comparison.error-source');
  var localeTarget = useLocale('date-comparison.error-target');

  var format = props.format,
      sourceOffset = props.sourceOffset,
      targetOffset = props.targetOffset,
      value = props.value,
      onChange = props.onChange,
      outRangeDisabled = props.outRangeDisabled,
      isDateDisabled = props.isDateDisabled,
      isMonthDisabled = props.isMonthDisabled,
      isYearDisabled = props.isYearDisabled,
      _props$startDay = props.startDay,
      startDay = _props$startDay === void 0 ? locale.startDay : _props$startDay,
      getDefaultTargetBySource = props.getDefaultTargetBySource,
      className = props.className,
      clearable = props.clearable,
      needRangeValid = props.needRangeValid,
      _props$sourcePresets = props.sourcePresets,
      sourcePresets = _props$sourcePresets === void 0 ? [] : _props$sourcePresets,
      getTargetPresets = props.getTargetPresets,
      size = props.size,
      placement = props.placement,
      disabled = props.disabled,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? localePlaceholder : _props$placeholder,
      footer = props.footer,
      _props$hideComparison = props.hideComparisonSwitch,
      hideComparisonSwitch = _props$hideComparison === void 0 ? false : _props$hideComparison,
      extra = _objectWithoutProperties(props, ["format", "sourceOffset", "targetOffset", "value", "onChange", "outRangeDisabled", "isDateDisabled", "isMonthDisabled", "isYearDisabled", "startDay", "getDefaultTargetBySource", "className", "clearable", "needRangeValid", "sourcePresets", "getTargetPresets", "size", "placement", "disabled", "placeholder", "footer", "hideComparisonSwitch"]);

  var cls = classnames(usePrefixCls('compare-range-date-picker', {
    date: true,
    range: true
  }), className);
  var panelCls = classnames(usePrefixCls('range-date-panel', {
    date: true,
    range: true
  }), className);
  var onChangeCallback = useRefCallback(onChange);
  var originValueRef = useRef(value);

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      innerValue = _useState4[0],
      setInnerValue = _useState4[1];

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      show = _useToggle2[0],
      setShow = _useToggle2[1],
      setHide = _useToggle2[2];

  if (originValueRef.current !== value) {
    originValueRef.current = value;
    setInnerValue(value);
  }

  var handleOnChange = useCallback(function (newVal) {
    setInnerValue(newVal);
  }, []);

  var _useCompareRangeDate = useCompareRangeDate({
    locale: locale,
    format: format,
    sourceOffset: sourceOffset,
    targetOffset: targetOffset,
    value: innerValue,
    onChange: handleOnChange,
    getDefaultTargetBySource: getDefaultTargetBySource,
    outRangeDisabled: outRangeDisabled,
    disabled: disabled,
    isDateDisabled: isDateDisabled,
    isMonthDisabled: isMonthDisabled,
    isYearDisabled: isYearDisabled,
    startDay: startDay,
    onUpdatePanelDate: updateRangePanelDate,
    onSetPanelDate: setRangePanelDate,
    parts: ['left', 'right'],
    panelType: PanelType.DATE,
    needRangeValid: needRangeValid
  }),
      root = _useCompareRangeDate.root,
      onSetSourcePreset = _useCompareRangeDate.onSetSourcePreset,
      onSetSourcePresetTrying = _useCompareRangeDate.onSetSourcePresetTrying,
      onCancelSourcePresetTrying = _useCompareRangeDate.onCancelSourcePresetTrying,
      onSetTargetPreset = _useCompareRangeDate.onSetTargetPreset,
      onSetTargetPresetTrying = _useCompareRangeDate.onSetTargetPresetTrying,
      onCancelTargetPresetTrying = _useCompareRangeDate.onCancelTargetPresetTrying;

  var onResetPanel = useCallback(function () {
    root.sourceRangeDate.resetTryingState();
    root.sourceRangeDate.revertPanelSelected();
    root.sourceRangeDate.repaintPanel();
    root.targetRangeDate.resetTryingState();
    root.targetRangeDate.revertPanelSelected();
    root.targetRangeDate.repaintPanel();
  }, []);
  var handleHide = useCallback(function () {
    onResetPanel();
    setHide();
    setInnerValue(originValueRef.current);
    setTab(ActiveTab.SOURCE);
  }, []);
  var handleOnOk = useCallback(function () {
    onChangeCallback(innerValue);
    handleHide();
  }, [innerValue]);
  var handleOnCancel = useCallback(function () {
    setInnerValue(originValueRef.current);
    handleHide();
  }, []);
  var handleClear = useCallback(function () {
    onChangeCallback({
      source: [],
      isCompare: false,
      target: []
    });
  }, []);
  var compareChange = useCallback(function (compare) {
    setInnerValue({
      source: innerValue.source,
      isCompare: compare,
      target: compare ? innerValue.target : []
    });
    setTab(compare ? ActiveTab.TARGET : ActiveTab.SOURCE);
  }, [innerValue]);
  var disableOk = true;
  var footerTipErrCls = usePrefixCls('compare-range-date-footer-extra-err');
  var footerTip = useMemo(function () {
    if (innerValue.isCompare && (innerValue.source.length < 2 || innerValue.target.length < 2)) {
      disableOk = false;
      return React.createElement("div", {
        className: footerTipErrCls
      }, innerValue.source.length < 2 ? localeSource : localeTarget);
    }

    return null;
  }, [innerValue]);
  var tabChange = useCallback(function (newTab) {
    setTab(newTab);
  }, []);
  var renderHeader = React.createElement(CompareRangeDateHeader, {
    value: innerValue,
    onCompareChange: compareChange,
    onTabChange: tabChange,
    active: tab,
    comparisonSwitch: !hideComparisonSwitch
  });
  var offset = root.getOffset();
  var localeMOM = useLocale('date-comparison.mom');
  var localeYOY = useLocale('date-comparison.yoy');

  var renderPresets = function renderPresets() {
    var p = [];

    if (tab === ActiveTab.SOURCE) {
      p = sourcePresets;
    } else {
      p = getTargetPresets ? getTargetPresets(root.sourceRangeDate.getValue(), offset) : defaultGetTargetPresets(root.sourceRangeDate.getValue(), offset, localeMOM, localeYOY);
    }

    if (!p.length) {
      return null;
    }

    return React.createElement(DatePreset, {
      presets: p,
      onPresetItemClick: tab === ActiveTab.SOURCE ? onSetSourcePreset : onSetTargetPreset,
      onPresetItemMouseEnter: tab === ActiveTab.SOURCE ? onSetSourcePresetTrying : onSetTargetPresetTrying,
      onPresetItemMouseLeave: tab === ActiveTab.SOURCE ? onCancelSourcePresetTrying : onCancelTargetPresetTrying
    });
  };

  var renderTrigger = function renderTrigger() {
    var inPopper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return React.createElement(DateComparisonInput, {
      value: value,
      placeholder: placeholder
    });
  };

  var renderFooter = React.createElement(CompareRangeDateFooter, {
    extra: footer || footerTip,
    onOk: handleOnOk,
    onCancel: handleOnCancel,
    disableOk: disableOk
  });
  return React.createElement("div", Object.assign({}, extra, {
    className: cls
  }), React.createElement(RcPopper, null, React.createElement(MultiplePopperWrapper, {
    show: show,
    multiple: false,
    placement: placement,
    placeholder: placeholder,
    clearable: clearable,
    size: size,
    onShow: setShow,
    onHide: handleHide,
    width: '250px',
    disabled: disabled,
    onClear: handleClear,
    renderTrigger: renderTrigger
  }, React.createElement(DateContainer, {
    header: renderHeader,
    footer: renderFooter,
    onResetPanel: onResetPanel,
    preset: renderPresets()
  }, React.createElement("div", Object.assign({}, extra, {
    className: cls,
    ref: panelRef,
    onMouseLeave: onResetPanel
  }), React.createElement(RcCompareRangeDateProvider, {
    root: root
  }, React.createElement("div", {
    className: panelCls,
    style: {
      display: tab === ActiveTab.SOURCE ? undefined : 'none'
    },
    key: ActiveTab.SOURCE
  }, React.createElement(RcDateProvider, {
    root: root.sourceRangeDate
  }, React.createElement(ViewWrapper, {
    enableInvalidTooltip: true,
    part: "left",
    prefix: "date",
    position: RangeState.START
  }), React.createElement(ViewWrapper, {
    enableInvalidTooltip: true,
    part: "right",
    prefix: "date",
    position: RangeState.END
  }))), React.createElement("div", {
    className: panelCls,
    style: {
      display: tab === ActiveTab.TARGET ? undefined : 'none'
    },
    key: ActiveTab.TARGET
  }, React.createElement(RcDateProvider, {
    root: root.targetRangeDate
  }, React.createElement(ViewWrapper, {
    enableInvalidTooltip: true,
    part: "left",
    prefix: "date",
    position: RangeState.START
  }), React.createElement(ViewWrapper, {
    enableInvalidTooltip: true,
    part: "right",
    prefix: "date",
    position: RangeState.END
  })))))))));
}